'use client';

import { FC, useState } from 'react';
import { AddToCartButtonProps, ButtonVariants } from './types';
import BaseButton from '@/components/Button/BaseButton';
import clsx from 'clsx';
import yieldToMain from '@/utils/yieldToMain';
import styles from './AddToCartButton.module.css';

const AddToCartButton: FC<AddToCartButtonProps> = ({ handleAddToCart, addToCartOption, disabled = false, id }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const mapButtonStyles = (buttonVariant: ButtonVariants): string => {
    const buttonVariants: Record<number, string> = {
      [ButtonVariants.specialOrders]: 'btnPrimary',
      [ButtonVariants.preOrder]: 'btnSecondary',
      [ButtonVariants.info]: 'btnBase',
      [ButtonVariants.productDetails]: 'btnBase',
      [ButtonVariants.notAvailble]: `${styles.outOfStock} btnBase`,
      [ButtonVariants.contactUs]: 'btnBase',
      [ButtonVariants.viewAdditionalItems]: 'btnBase',
    };
    return buttonVariants[buttonVariant];
  };

  return (
    <BaseButton
      id={id}
      classes={clsx(styles.addTocartButton, mapButtonStyles(addToCartOption.id))}
      label={addToCartOption.text === 'Pre Order' ? 'Pre-Order' : addToCartOption.text}
      disabled={loading || disabled}
      loading={loading}
      onClick={async () => {
        await yieldToMain();
        setLoading(true);
        await handleAddToCart();
        setLoading(false);
      }}
    />
  );
};

export default AddToCartButton;
